<div app-layout>
  <header>
    <div class="mb-4 flex items-center justify-end">
      <button
        type="button"
        (click)="onOpenReportTemp()"
        app-icon-button
        translate
        class="group mx-2 border border-theme-800 uppercase text-theme-800 shadow-md duration-300 hover:bg-theme-800 hover:text-theme-contrast"
      >
        <svg-icon
          class="mr-2 flex h-5 w-5 justify-center text-theme-800 duration-300 group-hover:text-theme-contrast"
          src="assets/icons/icon-report.svg"
        ></svg-icon>
        trilhas.acompanhar-relatorio-vitrine
      </button>

      <button
        type="button"
        (click)="onCreateCategory()"
        app-icon-button
        translate
        class="group mx-2 border border-theme-800 text-theme-800 shadow-md duration-300 hover:bg-theme-800 hover:text-theme-contrast"
      >
        <svg-icon
          class="mr-2 flex h-5 w-5 justify-center text-theme-800 duration-300 group-hover:text-theme-contrast"
          src="assets/icons/icon-plus.svg"
        ></svg-icon>
        trilhas.nova-categoria
      </button>
    </div>
  </header>
  <main>
    <ng-container *ngIf="loading$ | async; else loading">
      <div *ngIf="categories$ | async as categories">
        <ng-container *ngIf="!!categories.length && !!(categoriesSelected$ | async).length; else empty">
          <div *ngFor="let category of categories; index as catIndex">
            <ng-container *ngIf="filtered(category.id, categoriesSelected$ | async)">
              <div
                class="group mt-5 flex items-center justify-between bg-white shadow"
                [ngClass]="{ 'mb-3 rounded-xl': !category.colecoes?.length, 'rounded-t-xl': category.colecoes?.length }"
              >
                <div [formGroup]="getCategoryTitleForm(category)" class="flex w-full items-center justify-start">
                  <input
                    [id]="category.id ? category.id + '-category-input' : 'new-category-input'"
                    type="text"
                    class="mx-2 w-full rounded border-none bg-transparent px-4 py-5 text-lg text-theme-500 placeholder:italic placeholder:text-theme-300 focus:font-semibold focus:outline-none focus:ring-0"
                    [ngClass]="{ '!text-red-500': getCategoryTitleForm(category).invalid }"
                    formControlName="nome"
                    [placeholder]="'trilhas.estudio.placeholder-nova-categoria' | translate"
                  />
                </div>
                <div
                  class="group -bottom-6 right-8 flex justify-center opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"
                >
                  <button
                    app-tooltip
                    [tooltip]="'trilhas.estudio.tooltip-excluir-categoria' | translate"
                    *ngIf="!category.colecoes?.length"
                    type="button"
                    (click)="onDeleteCategory(category)"
                  >
                    <svg-icon
                      class="mr-5 flex h-8 w-8 p-1 text-theme-500 opacity-0 transition-opacity duration-300 ease-in-out hover:text-theme-950 group-hover:opacity-100"
                      src="assets/icons/icon-trash.svg"
                    ></svg-icon>
                  </button>
                  <button
                    *ngIf="category.id"
                    type="button"
                    app-tooltip
                    [tooltip]="'trilhas.estudio.tooltip-nova-colecao' | translate"
                    class="mr-5 rounded-full bg-[#fafafa] p-2 shadow-md ring-1 ring-theme-500 duration-300 hover:bg-theme-800 hover:ring-4 hover:ring-theme-200"
                    (click)="onCreateCollection(category.id, category.colecoes?.length + 1)"
                  >
                    <svg-icon
                      class="flex h-6 w-6 p-1 text-theme-500 duration-300 hover:text-theme-50"
                      src="assets/icons/icon-plus.svg"
                    ></svg-icon>
                  </button>
                </div>
              </div>
              <app-accordion
                *ngIf="!!category.colecoes?.length"
                class="flex flex-col rounded-b-xl bg-white/25 px-2 pt-2 shadow"
                cdkDropList
                #sectionsList="cdkDropList"
                [cdkDropListData]="category.colecoes"
                (cdkDropListDropped)="onDropSection($event, catIndex)"
              >
                <ng-container *ngFor="let collection of category.colecoes; index as colIndex">
                  <app-collection-studio
                    cdkDrag
                    [colIndex]="colIndex"
                    [categories]="categories"
                    [collection]="category.colecoes[colIndex]"
                    [category]="category"
                    [collectionsSelected]="collectionsSelected$ | async"
                    [coursesSelected]="coursesSelected$ | async"
                    [products]="products$ | async"
                  ></app-collection-studio>
                </ng-container>
              </app-accordion>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="h-full p-4">
        <app-jumbotron class="p-5" translate>geral.filtro-vazio</app-jumbotron>
      </div>
    </ng-template>

    <ng-template #loading>
      <div class="ml-2 animate-pulse">
        <div class="h-8 w-96 rounded bg-[#dedfe3]"></div>
      </div>

      <app-card
        *ngFor="let item of [1, 2, 3]"
        class="duration-50 mt-4 h-[5rem] w-full justify-start self-center !rounded-2xl"
      >
        <div app-card-content class="flex h-full w-[38rem]">
          <svg-icon src="assets/icons/icon-files-close.svg" class="mr-2 h-10 w-10 p-1 text-theme-500"></svg-icon>
          <app-skeleton></app-skeleton>
        </div>
      </app-card>
    </ng-template>
  </main>
</div>
